import React from "react";
const JbpDivAvgSpeed = () => {
  return <div> JbpDivAvgSpeed</div>;
};
export default JbpDivAvgSpeed;
